import React from 'react';
import { useTranslation } from 'react-i18next';
import Loader from '@wix/da-ds/pkg/Loader/Loader';
import ProgressBar from '@wix/da-ds/pkg/ProgressBar/ProgressBar';

import s from './UploadingLoader.scss';

interface Props {
  uploadProgress?: number;
}

const UploadingLoader: React.FC<Props> = ({ uploadProgress }) => {
  const { t } = useTranslation();
  return (
    <div className={s['root']}>
      <Loader size="big" state="eating" />
      {uploadProgress ? (
        <ProgressBar progress={uploadProgress} className={s['progress-bar']} />
      ) : null}
      <div className={s['progress-title']}>
        {t('uploadZone.progress.title')}
      </div>
    </div>
  );
};

export default UploadingLoader;
